export enum ToolbarType {
  QUICK_ACTIONS = 'QUICK_ACTIONS',
  SIDE = 'SIDE',
  MOBILE = 'MOBILE',
  FOOTER = 'FOOTER',
  STATIC = 'STATIC',
  INLINE = 'INLINE',
  PLUGIN = 'PLUGIN',
  FORMATTING = 'FORMATTING',
  INSERT_PLUGIN = 'INSERT_PLUGIN',
  TEXT = 'ALL-TEXT-TOOLBARS',
  SHORTCUT = 'SHORTCUT',
  LINK = 'LINK',
  EXTERNAL = 'EXTERNAL',
  PLUGIN_MENU = 'PLUGIN_MENU',
  EMPTY = 'EMPTY',
}

export enum DisplayMode {
  NORMAL = 'NORMAL',
}
